'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var react = require('react');

var useModal = function (_a) {
    var _b = _a === void 0 ? {} : _a, isChild = _b.isChild, parentIsOpen = _b.parentIsOpen, _c = _b.transitionTimeMS, transitionTimeMS = _c === void 0 ? 500 : _c;
    var _d = react.useState(false), isOpen = _d[0], setIsOpen = _d[1];
    var open = function () { return setIsOpen(true); };
    var close = function () { return setIsOpen(false); };
    react.useEffect(function () {
        // Close children (after animation) when parent closes
        if (isOpen && isChild && !parentIsOpen) {
            setTimeout(close, transitionTimeMS);
        }
    }, [transitionTimeMS, isChild, isOpen, parentIsOpen]);
    return { isOpen: isOpen, open: open, close: close };
};
var useModal$1 = useModal;

exports.default = useModal$1;
//# sourceMappingURL=useModal.js.map
